<template>
  <div>
    <el-form ref="DetailForm" :model="DetailForm" label-width="110px" style="margin-top:10px;margin-bottom:60px;">
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="名称" prop="b_name">
                <el-input v-model="DetailForm.b_name" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="类别" prop="b_source">
                <el-radio-group v-model="DetailForm.b_source">
                    <el-radio :label="0">PC端</el-radio>
                    <el-radio :label="1">移动端</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="所属专题" prop="b_topic">
                <el-select v-model="DetailForm.b_topic" placeholder="请选择" disabled>
                <el-option
                    v-for="item in topicOptions"
                    :key="item.t_id"
                    :label="item.t_name"
                    :value="item.t_id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="跳转链接" prop="b_url">
                <el-input v-model="DetailForm.b_url" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="封面" prop="b_cover">
            <el-upload
                :class="{disabled:uploadDisabledCover}"
                :action="uploadAddress"
                list-type="picture-card"
                name="file"
                :limit="1"
                ref="DetailUpload"
                disabled
                :on-preview="handleAddPreview"
                :file-list="DetailFileListCover">
                <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="AddPreviewDialogVisible">
              <img width="100%" :src="AddPreviewDialogImageUrl" alt="">
            </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>

    <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'advertisementdetail',
  data() {
      return {
          DetailForm : {},
          topicOptions : [],
          DetailFileListCover : [],

          uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址
          AddPreviewDialogVisible : false,
          AddPreviewDialogImageUrl : '',
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      getInfo() {
          this.$http.get(`${api.dev}/p/main/banner/select`,{params: {access_token: getToken(), b_id : this.$route.params.id}}).then(res => {
              if(res.body.code == 200) {
                    this.DetailForm = res.body.content;
                    // if(this.DetailForm.b_topic == 0) {
                    //     this.DetailForm.b_topic = '首页'
                    // }

                    this.DetailFileListCover = [{url:`${api.address}${this.DetailForm.b_cover}`}]
              }else if(res.body.code == 500) {
                  this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
              }else if(res.body.code == 510) {
                  this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
                    removeToken();
                    setTimeout(function () {
                        this.$router.push({path: '/login'});
                    },2000)
              }
          })
      },
      // 获取所有专题
      getAllTopic() {
          this.$http.get(`${api.dev}/p/main/drop/selectTopic`,{params : {access_token : getToken()}}).then(res => {
              if(res.body.code == 200) {
                //   this.topicMsg = res.body.content;
                  var indexTop = [{t_id : 0, t_name : '首页'}]
                  this.topicOptions = indexTop.concat(res.body.content);
              }else if(res.body.code == 500) {
                  this.$message({
                    message: res.body.msg,
                    type: 'error'
                  });
                  removeToken();
                  setTimeout(function () {
                    this.$router.push({path: '/login'});
                  },2000)
              }
          })
      },
      handleAddPreview(file) {
        this.AddPreviewDialogVisible = true;
        this.AddPreviewDialogImageUrl = file.url;
      },
  },
  created() {
      this.getInfo()
      this.getAllTopic()
  },
  computed : {
      uploadDisabledCover:function() {
            return this.DetailForm.b_cover != '0'
        },
  }
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
    margin-right -15px
form.el-form 
    width 1180px;
</style>
